import Icon, { IconName } from 'atoms/Icon'
import { MessageDirection } from 'common/types/kraken-core/Message'

const MessageDirectionIcon = ({ direction }: { direction: string }) => {
  const isInboundDirection = direction === MessageDirection.INBOUND
  const arrowIcon: IconName = isInboundDirection ? 'arrow-left' : 'arrow-right'
  return (
    <div style={{ animationName: 'spin', animationDuration: '0.5s' }}>
      <Icon name={arrowIcon} size={20} />
    </div>
  )
}

export default MessageDirectionIcon
